import { useEffect } from "react";
import { useLocation } from "react-router-dom";

/**
 * Scrolls window to top on every route change AND on initial mount.
 * Also disables the browser's automatic scroll-restoration so that
 * mobile Chrome doesn't dump users at the bottom of the page after
 * React hydration replaces the larger static SEO content.
 *
 * Mount once at the top of <App />.
 */
export default function ScrollToTop() {
  const { pathname } = useLocation();

  useEffect(() => {
    if ("scrollRestoration" in window.history) {
      window.history.scrollRestoration = "manual";
    }
  }, []);

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);

  return null;
}
